import { ICreateClienteArquivoUseCase } from "../../../presentation/useCases/create/create_cliente_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateClienteArquivoUseCase
 */

export class CreateClienteArquivoUseCase implements ICreateClienteArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    idCliente?: number,
    descricao?: string,
    arquivo?: File,
  ): Promise<number> {

    return this.repository.createClienteArquivo(
      idCliente,
      arquivo ? arquivo.name : undefined,
      descricao,
      arquivo
    );
  }
}
